import { getDataMapper, mapArray, mapField } from "@/shared";

export const mapReminderFromServer = getDataMapper({
    id: mapField("id", Number),
    remindAt: mapField("remind_at"),
    body: mapField("body"),
    isDone: mapField("is_done", Boolean),
    doneAt: mapField("done_at"),
});

export const mapRemindersFromServer = mapArray(mapReminderFromServer);
